import Axios from 'axios'
import Qs from 'qs'
import { handleError } from '@/plugins/axiosError'

function configAxios() {
  Axios.defaults.baseURL = '/tenant/api'
  Axios.defaults.paramsSerializer = params => Qs.stringify(params, { arrayFormat: 'repeat' })
  Axios.interceptors.response.use(
    response => response,
    (error) => {
      if (error && error.config && error.config.ignoreError) {
        console.log('error', error)
      } else {
        handleError(error)
      }
      return Promise.reject(error)
    },
  )
}

(function () {
  configAxios()
}())
